import { useState, useCallback } from "react";
import { AlertConfig } from "../components/AlertPopup";

export const useAlert = () => {
  const [alert, setAlert] = useState<AlertConfig | null>(null);

  const showAlert = useCallback(
    (config: Omit<AlertConfig, "type"> & { type?: AlertConfig["type"] }) => {
      setAlert({
        type: "info",
        confirmText: "OK",
        ...config,
      });
    },
    [],
  );

  const showError = useCallback(
    (title: string, message: string, options?: Partial<AlertConfig>) => {
      setAlert({
        type: "error",
        title,
        message,
        confirmText: "OK",
        ...options,
      });
    },
    [],
  );

  const showSuccess = useCallback(
    (title: string, message: string, options?: Partial<AlertConfig>) => {
      setAlert({
        type: "success",
        title,
        message,
        confirmText: "OK",
        ...options,
      });
    },
    [],
  );

  const showWarning = useCallback(
    (title: string, message: string, options?: Partial<AlertConfig>) => {
      setAlert({
        type: "warning",
        title,
        message,
        confirmText: "OK",
        ...options,
      });
    },
    [],
  );

  const showConfirm = useCallback(
    (
      title: string,
      message: string,
      onConfirm: () => void,
      options?: Partial<AlertConfig>,
    ) => {
      setAlert({
        type: "warning",
        title,
        message,
        confirmText: "Confirm",
        showCancel: true,
        cancelText: "Cancel",
        onConfirm,
        ...options,
      });
    },
    [],
  );

  const hideAlert = useCallback(() => {
    setAlert(null);
  }, []);

  return {
    alert,
    showAlert,
    showError,
    showSuccess,
    showWarning,
    showConfirm,
    hideAlert,
  };
};
